import { walletStatusConstants } from "../constants/action.constants";
import { walletStatusService } from "../services/walletStatus.service";
import { alertActions } from "../../../Alert/actions/alert.actions";
import { message } from "../../../../_constants";

export const walletStatusActions = {
  getWalletStatus
};

function getWalletStatus(params) {
  return async dispatch => {
    dispatch(request(params));
    try {
      const response = await walletStatusService.getWalletStatus(params);
      response && dispatch(success(response));
    } catch (error) {
      dispatch(failure(error));
      dispatch(
        alertActions.error(
          error ? error.message : message.GENERIC_ERROR,
          message.LOAD_CARD_STATUS
        )
      );
    }
  };

  function request(params) {
    return { type: walletStatusConstants.GET_WALLETSTATUS_REQUEST, params };
  }
  function success(response) {
    return { type: walletStatusConstants.GET_WALLETSTATUS_SUCCESS, response };
  }
  function failure(error) {
    return { type: walletStatusConstants.GET_WALLETSTATUS_FAILURE, error };
  }
}
